<app-authentication [autenticationType]="data.autenticationType"></app-authentication>
